import {Component} from '@angular/core';
import {OverrideAuditEntry} from '../inventory.model';

@Component({
    selector: 'app-override-audit-dialog',
    templateUrl: './override-audit-dialog.component.html',
    styleUrls: ['./override-audit-dialog.component.scss']
})
export class OverrideAuditDialogComponent {
    overrides: OverrideAuditEntry[] = [];
    loading = true;
    error: string | null = null;
}
